@let dataItem = entry();
@let idx = index();
@let canNav = canNavigate();
@let onboardingActive = onboardingInProgress();
@let guide = currentGuide();
@let step = currentStep();
@let actionsGuideVisible = entryActionsGuideVisible();

<div
  id="outlook-main-ui-read-viewEntry-{{ dataItem.tag }}"
  class="rounded-sm flex items-center justify-between p-1.5 gap-2 w-full transition-all border-2 border-transparent"
  [class.border-pulse-enter]="
    onboardingActive &&
    guide === StepGuideId.EntryActions1 &&
    inMaximizerLength() > 0 &&
    idx === 0
  "
  [class.hover:bg-bush-green-15]="
    canNav && (!onboardingActive || actionsGuideVisible)
  "
  [class.hover:cursor-pointer]="
    canNav && (!onboardingActive || actionsGuideVisible)
  "
  [attr.title]="viewEntryTitle()"
>
  <button
    class="flex items-center gap-2 grow min-w-0 border-0 bg-transparent p-0 text-left cursor-pointer"
    (click)="onNavigate()"
  >
    <div
      class="avatar avatar-sm shrink-0 text-black"
      [class]="dataItem | outlookAvatarClasses: userEmails()"
    >
      @if (
        (dataItem.type === 'abentry' ||
          (dataItem.type === 'lead' &&
            dataItem.emailAddress &&
            isUser(dataItem.emailAddress))) &&
        dataItem.abentryType !== 'company'
      ) {
        <span>{{ dataItem | outlookAvatarLetters }}</span>
      }
      @if (
        dataItem.type === 'lead' &&
        (!dataItem.emailAddress || !isUser(dataItem.emailAddress))
      ) {
        <span
          class="fa-icons icon icon-solid icon-12 icon-user-magnifying-glass m-auto"
        ></span>
      } @else if (dataItem.abentryType === 'company') {
        <span
          class="fa-icons icon icon-regular icon-16 icon-building m-auto"
        ></span>
      }
    </div>
    <div
      class="flex flex-col grow min-w-0 overflow-hidden"
      [class.pointer-events-auto]="onboardingActive && actionsGuideVisible"
    >
      <!-- Display Name -->
      <div class="flex items-center min-w-0">
        <p class="text-body truncate min-w-0 grow">
          {{ dataItem.displayName }}
        </p>
        @if (dataItem.isNewEntry) {
          <div
            class="bg-finserv-10 caption rounded-md py-0.5 px-1.5 ml-2 shrink-0"
          >
            <p>{{ 'outlook.main.new' | translate }}</p>
          </div>
        }
      </div>
      <!-- Email Address -->
      <div class="caption text-neutral-70 flex items-center min-w-0">
        <p class="truncate min-w-0">
          {{ dataItem.emailAddress }}
        </p>
        @if (autoSaveEnabled()) {
          <span
            kendoTooltip
            class="maximizer-icons icon-12 icon-synced-email text-neutral-90 ml-1 mt-1 shrink-0"
            title="{{ 'outlook.main.autoSaveEnabled' | translate }}"
            [callout]="false"
            [tooltipTemplate]="tooltipTemplate"
          ></span>
        }
      </div>
      <!-- Entry Type -->
      <p class="caption text-neutral-70 break-all">
        {{ entryTypeLabel() }}
      </p>
    </div>
  </button>
  <!-- Save Email Button -->
  <div
    kendoTooltip
    [callout]="false"
    [tooltipTemplate]="tooltipTemplate"
    [title]="
      dataItem.emailSaved
        ? ('outlook.main.tooltip.email-saved' | translate)
        : getSaveEmailPermission(dataItem.type)
          ? ('outlook.main.tooltip.save-email' | translate)
          : getSaveEmailPermissionMessage(dataItem.type, 'default')
    "
    [class.pointer-events-auto]="
      onboardingActive && step === OnboardingStepNumber.Step2
    "
  >
    <div class="relative inline-flex">
      @if (
        onboardingActive &&
        guide === StepGuideId.SaveEmail1 &&
        idx === 0
      ) {
        <span
          class="absolute top-[-3px] left-[-3px] flex h-3 w-3 pointer-events-none z-10"
        >
          <span
            class="animate-ping absolute inline-flex h-full w-full rounded-full bg-grass-green-120 opacity-75"
          ></span>
          <span
            class="relative inline-flex rounded-full h-3 w-3 bg-grass-green-120"
          ></span>
        </span>
      }
      <button
        kendoButton
        id="outlook-main-ui-read-saveEmail-{{ dataItem.tag }}"
        themeColor="primary"
        fillMode="flat"
        [disabled]="
          dataItem.emailSaved ||
          !getSaveEmailPermission(dataItem.type) ||
          (onboardingActive && step !== OnboardingStepNumber.Step2)
        "
        (click)="onSave()"
        [iconClass]="
          dataItem.emailSaved
            ? 'maximizer-icons icon-saved-email text-neutral-40 icon-20'
            : getSaveEmailPermission(dataItem.type)
              ? 'maximizer-icons icon-save-email icon-24'
              : 'maximizer-icons icon-save-email text-neutral-40 icon-24'
        "
      ></button>
    </div>
  </div>
</div>

<ng-template #tooltipTemplate let-anchor>
  <p class="caption text-center text-neutral-90 whitespace-nowrap">
    {{ anchor.nativeElement.getAttribute('data-title') }}
  </p>
</ng-template>
